import React, { useEffect, useState } from 'react';
import { Ingredient } from '../types';
import { detectAllergens, ALLERGENS } from '../data/allergens';
import { AllergenBadge } from './AllergenBadge';
import { X, AlertCircle } from 'lucide-react';
interface IngredientFormProps {
  ingredient?: Ingredient;
  onSave: (ingredient: Omit<Ingredient, 'id' | 'createdAt'>) => void;
  onCancel: () => void;
}
export function IngredientForm({
  ingredient,
  onSave,
  onCancel
}: IngredientFormProps) {
  const [name, setName] = useState(ingredient?.name || '');
  const [detectedAllergens, setDetectedAllergens] = useState<string[]>(ingredient?.allergens || []);
  useEffect(() => {
    if (name.trim()) {
      const detected = detectAllergens(name);
      setDetectedAllergens(detected);
    } else {
      setDetectedAllergens([]);
    }
  }, [name]);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!name.trim()) return;
    onSave({
      name: name.trim(),
      allergens: detectedAllergens
    });
  };
  return <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" data-id="element-131">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full" data-id="element-132">
        <div className="flex items-center justify-between p-6 border-b" data-id="element-133">
          <h2 className="text-xl font-semibold" data-id="element-134">
            {ingredient ? 'Zutat bearbeiten' : 'Neue Zutat'}
          </h2>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-600 transition-colors" data-id="element-135">
            <X className="w-5 h-5" data-id="element-136" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-137">
          <div data-id="element-138">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-139">
              Zutat Name
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none" placeholder="z.B. Weizenmehl, Senf, Milch..." autoFocus required data-id="element-140" />
          </div>

          {detectedAllergens.length > 0 && <div className="bg-amber-50 border border-amber-200 rounded-lg p-4" data-id="element-141">
              <div className="flex items-start gap-2 mb-3" data-id="element-142">
                <AlertCircle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-143" />
                <div data-id="element-144">
                  <h3 className="font-medium text-amber-900 text-sm" data-id="element-145">
                    Allergene erkannt
                  </h3>
                  <p className="text-xs text-amber-700 mt-1" data-id="element-146">
                    Diese Zutat wurde automatisch als Allergen identifiziert
                  </p>
                </div>
              </div>
              <div className="flex flex-wrap gap-2" data-id="element-147">
                {detectedAllergens.map(allergenId => <AllergenBadge key={allergenId} allergenId={allergenId} size="sm" data-id="element-148" />)}
              </div>
            </div>}

          <div className="flex gap-3 pt-4" data-id="element-149">
            <button type="button" onClick={onCancel} className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors font-medium" data-id="element-150">
              Abbrechen
            </button>
            <button type="submit" className="flex-1 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors font-medium" data-id="element-151">
              Speichern
            </button>
          </div>
        </form>
      </div>
    </div>;
}